import { render, staticRenderFns } from "./PaymentSucceed.vue?vue&type=template&id=4d33d85b&scoped=true"
import script from "./PaymentSucceed.vue?vue&type=script&lang=js"
export * from "./PaymentSucceed.vue?vue&type=script&lang=js"
import style0 from "./PaymentSucceed.vue?vue&type=style&index=0&id=4d33d85b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d33d85b",
  null
  
)

export default component.exports